var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.prefix = require("./prefix");
name.nobility_title_prefix = require("./nobility_title_prefix");
name.name = require("./name");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/name/index.js
 ** module id = 221
 ** module chunks = 0
 **/